module.exports = __webpack_public_path__ + "img/Panther-Boxing-Logo-Template.jpg";